import React, { useContext } from "react";
import dynamic from "next/dynamic";
import { colors, duration } from "../utils/styles";
import { HeaderContext } from "contexts/";
import "nprogress/nprogress.css";
const TopProgressBar = dynamic(
	() => {
		return import("./TopProgress");
	},
	{ ssr: false }
);

export default function Layout({ children }) {
	const { isMobileNavOpen } = useContext(HeaderContext);

	return (
		<div className={isMobileNavOpen ? "h-100" : ""}>
			<TopProgressBar />
			<main>{children}</main>
			<style jsx="true">{`
				main {
					display: flex;
					flex-direction: column;
					justify-content: flex-start;
					background: ${colors.lightGray};
					height: 100%;
				}
			`}</style>
			<style jsx="true" global>{`
				html,
				body,
				#__next {
					padding: 0;
					margin: 0;
					font-family: "Open Sans", Helvetica Neue, Arial, sans-serif;
					line-height: 1.5;
					height: 100%;
				}
				* {
					box-sizing: border-box;
				}
				.shoppingCart {
					width: 30px;
					color: ${colors.green};
				}
				.check-icon {
					width: 25px;
					display: inline;
					color: ${colors.white};
					margin-left: -0.5em;
					margin-right: 0.2em;
				}
				.avatar {
					width: 30px;
					color: ${colors.black};
				}

				.link {
					color: ${colors.green};
					word-break: break-all;
				}
				.link:visited {
					color: ${colors.green};
				}

				.list-wrap ul {
					display: flex;
					flex-wrap: wrap;
					padding: 0;
					margin: 0;
					list-style: disc;
				}

				.list-wrap li {
					padding: 10px;
					margin: 10px;
					font-size: 10px;
					display: flex;
					align-items: center;
					justify-content: center;
					align-content: center;
					box-shadow: 2px 2px 10px #0000002e;
				}
				.list-wrap p {
					margin: 0;
					color: ${colors.dark};
				}
				.general-text-m0 p {
					margin: 0;
				}

				/* Small devices (tablets) */
				@media only screen and (min-width: 576px) {
					.list-wrap li {
						width: calc(50% - 40px);
					}
				}

				/* Medium devices (desktops) */
				@media only screen and (min-width: 768px) {
					.list-wrap li {
						width: calc(33.33% - 40px);
					}
				}

				.TEST {
					border: 4px solid red;
				}
				.TEST-BLACK {
					border: 4px solid black;
				}
				.TEST-BLUE {
					border: 4px solid blue;
				}
				.TEST-GREEN {
					border: 4px solid green;
				}
				.TEST-YELLOW {
					border: 4px solid yellow;
				}

				/* Contentful Rich Text Editor likes to add empty p tags */
				/* https://github.com/contentful/rich-text/issues/101#issuecomment-553924366 */

				h1:empty,
				h2:empty,
				h3:empty,
				h4:empty,
				h5:empty,
				h6:empty,
				p:empty,
				div.paragraph:empty {
					display: none !important;
				}

				a,
				a:visited {
					color: inherit;
					text-decoration: none;
				}
				a:hover {
					color: inherit;
					text-decoration: underline;
				}

				.overflowHidden {
					overflow: hidden;
				}
				.variable-price-line-through {
					text-decoration-color: ${colors.green};
					text-decoration-line: line-through;
					z-index: 1;
				}

				.sticky-top {
					position: sticky !important;
					top: 0;
					background: inherit;
				}

				.z-index-10 {
					z-index: 10;
				}
				.z-index-0 {
					z-index: 0;
				}
				.z-index-1 {
					z-index: 1;
				}
				.z-index-neg-1 {
					z-index: -1;
				}
				.absolute {
					position: absolute;
				}
				.absolute-center {
					position: absolute;
					top: 50%;
					left: 50%;

					transform: translate(-50%, -50%);
				}
				 {
					/* Conf cards */
				}
				.absolute-center-right {
					position: absolute;
					top: 0%;
					left: 50%;

					transform: translate(-50%, -135%);
				}

				.absolute-middle-right_TSA {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					right: 0%;
				}
				.absolute-middle-left {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					left: 0%;
				}

				.absolute-middle-right {
					position: absolute;
					top: 10%;
					right: 0%;
				}
				.absolute-bottom-left {
					position: absolute;
					bottom: 5%;
					left: 5%;
				}
				.relative {
					position: relative;
				}
				.expand {
					animation: grow ${duration.navGrow};
				}
				.myShow {
					animation: fadeIn ${duration.navFade};
				}

				.myFade {
					animation: fadeOut ${duration.navFade};
				}
				.spin {
					animation: spin 1s linear infinite;
				}
				/* .inLeft {
					animation: slideInLeft ${duration.navFade};
				} */
				.bg-white {
					background-color: ${colors.white};
				}

				.bg-red {
					background-color: red;
					opacity: 0.5;
				}
				.look-disabled {
					opacity: 0.5;
				}
				.light-blue-green-gradient > * {
					background: linear-gradient(to bottom right, #2d6fa7, #32a8a4);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
				.bg-yellow {
					background: ${colors.yellow};
				}
				.grayScale {
					filter: invert(3.5%);
				}
				.light-grayScale {
					filter: invert(2%);
				}
				.cover {
					min-width: auto !important;
					min-height: auto !important;
					width: 100% !important;
					height: auto !important;
					object-fit: cover !important;
				}
				.min-height-auto {
					min-height: auto !important;
				}
				.round {
					border-radius: 50%;
				}

				.radius-50px {
					border-radius: 50px;
				}

				.radius-35px {
					border-radius: 35px;
				}

				.radius-30px {
					border-radius: 30px;
				}

				.radius-20px {
					border-radius: 20px;
				}

				.radius-right-20px {
					border-radius: 0 20px 20px 0;
				}
				.radius-left-20px {
					border-radius: 20px 0 0 20px;
				}

				.radius-5px {
					border-radius: 5px;
				}

				.ms-n4 {
					margin-left: -1.5em;
				}

				.boxShadow {
					box-shadow: 2px 2px 10px #0000002e;
				}

				.whiteBoxShadow {
					box-shadow: 2px 2px 10px #ffffff2e;
				}

				.min-h-400 {
					min-height: 400px;
				}
				.min-h-450 {
					min-height: 450px;
				}
				.min-h-650 {
					min-height: 650px;
				}
				.min-h-200 {
					min-height: 200px;
				}

				.width-80 {
					width: 80px;
				}

				.width-90 {
					width: 90px;
				}
				.width-700 {
					width: 700px;
				}

				.btn-close {
					position: absolute;
					top: 1em;
					right: 1em;
				}

				.background-img-quote {
					background: url(https://images.ctfassets.net/mdag2z2o3c18/2c0o9IgPzddNWci8WQoi4i/b91dfbf48d1b9991b28b82d3e6fe6958/quote.png)
						no-repeat !important;
					background-position: 30% 0% !important;
				}

				.flex-1 {
					flex: 1 !important;
				}

				.float-left {
					float: left;
					width: auto !important;
				}
				.imageCard.float-left {
					padding-right: 1em;
				}
				.padding-top-0 {
					padding-top: 0 !important;
				}

				.float-right {
					float: right;
					width: auto !important;
				}
				.float-right-min {
					float: right;
				}
				.imageCard.float-right {
					padding-left: 1em;
				}

				.full-width-image-container {
					width: 100% !important;
				}

				.full-width-image-container span {
					width: 100% !important;
				}

				.text-size-9 {
					font-size: 10px !important;
					line-height: 12px !important;
				}

				.line-height-30 {
					line-height: 30px !important;
				}
				.padding-top-35 {
					padding-top: 35px !important;
				}

				.height-200 {
					height: 200px !important;
				}
				.height-150 {
					height: 150px !important;
				}

				.w-max-content {
					width: max-content;
				}
				.w-auto {
					width: auto;
				}
				.w-fit {
					width: fit-content;
				}
				.w-10px {
					min-width: 10px;
					max-width: 10px;
				}
				.w-20px {
					min-width: 20px !important;
					max-width: 20px !important;
				}
				.w-30px {
					min-width: 30px;
					max-width: 30px;
				}
				.w-40px {
					min-width: 40px;
					max-width: 40px;
				}
				.w-50px {
					min-width: 50px;
					max-width: 50px;
				}

				.w-100px {
					min-width: 100px;
					max-width: 100px;
				}
				.w-230px {
					min-width: 230px;
					max-width: 230px;
				}
				.w-200px {
					min-width: 200px;
					max-width: 200px;
				}
				.mw-250px {
					max-width: 250px;
				}

				.w-300px {
					min-width: 300px;
					max-width: 300px;
				}
				.w-400px {
					min-width: 400px;
					max-width: 400px;
				}
				.w-450px {
					min-width: 450px;
					max-width: 450px;
				}
				.w-500px {
					min-width: 500px;
					max-width: 500px;
				}
				.mw-175px {
					max-width: 175px;
				}
				.mw-300px {
					max-width: 300px;
				}
				.mw-400px {
					max-width: 400px;
				}
				.mw-450px {
					max-width: 450px;
				}
				.mw-500px {
					max-width: 500px;
				}
				.mw-650px {
					max-width: 650px;
				}
				.mw-930px {
					max-width: 930px;
				}

				/* Product card image height */
				.mh-280px {
					max-height: 280px !important;
				}

				.mh-500px {
					max-height: 500px !important;
				}
				.mh-750px {
					max-height: 750px !important;
				}

				.bookBorder {
					border: 1px solid black;
					margin-top: 3px;
				}

				.membersLink {
					color: ${colors.green};
					text-decoration: underline;
				}

				.course-label-gray {
					display: inline-block;
					padding: 5px 10px;
					background-color: #eeeded;
					border-radius: 4px;
					color: ${colors["greyBlue"]};
					white-space: nowrap;
					margin: 5px 0px;
				}

				.course-completed {
					border: 2px solid ${colors.green};
				}

				.course-enrolled {
					border: 2px solid ${colors.yellow};
				}

				ul .bg-light-blue-ul {
					background-color: #e7f0f7 !important;
					border-radius: 3px;
				}
				.new-label {
					background: #184360 !important;
					font-size: 12px !important;
					border-radius: 3px;
				}
				.live-label {
					background: ${colors.red} !important;
					font-size: 12px !important;
					border-radius: 3px;
				}
				.white-text-shadow {
					text-shadow: 1px 1px 5px ${colors["white"]};
				}
				.black-text-shadow {
					text-shadow: 1px 1px 5px ${colors["black"]};
				}

				.purple-border {
					border: 2px solid ${colors["purple"]};
				}

				.border-yellow {
					border: 2px solid ${colors.yellow};
				}

				button:disabled {
					cursor: not-allowed;
				}
				button:disabled > * {
					cursor: not-allowed;
				}

				.border-black {
					border: 4px solid ${colors.black};
				}
				.border-gray {
					border: 4px solid ${colors.darkGray};
				}

				.border-white-1 {
					border: 1px solid ${colors.white};
				}
				.border-dash {
					border: 2px ${colors.mediumGray} dashed;
				}
				.border-left-none {
					border-left: none;
				}
				.border-right-none {
					border-right: none;
				}
				.content-list li {
					margin-bottom: 10px;
				}
				.yellow-bullet ul {
					list-style: none;
				}

				/* Base styles shared by all bullet types */
				.custom-bullet-dot-triangle ul {
					list-style: none;
					padding-left: 0;
					margin: 0;
				}

				.custom-bullet-dot-triangle li {
					position: relative;
					padding-left: 25px;
					margin-bottom: 1px;
					display: flex;
					align-items: flex-start;
				}

				/* Base bullet styling */
				.custom-bullet-dot-triangle li::before {
					content: "";
					position: absolute;
					left: 0;
					top: 5px;
					width: 15px;
					height: 15px;
					background-size: contain;
					background-repeat: no-repeat;
					background-position: center;
				}

				/* Color-specific classes */
				.custom-bullet-dot-triangle-red li::before {
					background-image: url("/img/dot-triangle-red.svg");
				}

				.custom-bullet-dot-triangle-blue li::before {
					background-image: url("/img/dot-triangle-blue.svg");
				}
				.react-multiple-carousel__arrow.react-multiple-carousel__arrow--left {
					position: absolute;
					left: 0;
				}
				.react-multiple-carousel__arrow.react-multiple-carousel__arrow--right {
					position: absolute;
					right: 0;
				}

				.custom-bullet-dot-triangle-yellow li::before {
					background-image: url("/img/dot-triangle-yellow.svg");
				}

				.list-style-none ul {
					list-style: none;
					margin-left: -2em;
				}
				.yellow-bullet ul li p {
					display: inline-flex;
					margin-bottom: 0px;
				}
				.yellow-bullet li::before {
					content: "•";
					font-size: 30px;
					color: ${colors.yellow};
					display: inline-block;
					width: 1em;
					margin-left: -1em;
				}

				.no-wrap {
					white-space: nowrap;
				}

				.competency-card ul li .paragraph {
					line-height: 22px;
					margin-bottom: 0.5em;
					font-size: 20px;
				}
				.competency-card ul {
					margin-top: 4px;
				}

				.competency-card {
					background-size: auto !important;
					background-position: 30% 70% !important;
				}

				.icon {
					width: 10px;
					line-height: 1em;
					cursor: pointer;
					margin: 0.5em;
					background: inherit;
				}

				.external-link-icon {
					width: 12px;
					line-height: 1em;
					cursor: pointer;
					margin: 0px;
					background: inherit;
				}
				.ButtonGroupComponent .external-link-icon {
					display: none;
				}

				.clickable {
					cursor: pointer;
				}

				.hoverable {
					transition: all 0.3s ease-in-out;

					border: 1px solid transparent;
				}
				.hoverable:hover {
					border: 1px solid ${colors.green};
				}
				.no-drop {
					cursor: no-drop;
				}

				.form-check-input {
					cursor: pointer;
				}
				.form-check-input:disabled {
					cursor: no-drop;
				}

				.margin-top-auto {
					margin-top: auto !important;
				}

				.learn-more {
					display: inline-flex;
					align-items: center;
					gap: 4px;
					text-decoration: none;
				}

				.with-chevron::after {
					margin-left: 0.5em;
					font-weight: bold;
					font-size: 20px;
					content: "›"; /* Direct character */
				}

				.learn-more:hover::after {
					transform: translateX(4px);
				}

				.no-can {
					opacity: 0.5;

					color: rgb(33, 37, 41);
				}

				.even-row {
					background: #cfcfcf;
				}

				.force-item-end {
					flex-grow: 1;
					align-items: end;
				}
				.top-left {
					top: 0px;
					left: 0px;
				}

				.canvas-center {
					position: absolute;
					top: 50%;
					left: 50%;
					-webkit-transform: translate(-50%, -50%);
					-moz-transform: translate(-50%, -50%);
					-ms-transform: translate(-50%, -50%);
					-o-transform: translate(-50%, -50%);
					transform: translate(-50%, -50%);
					-webkit-font-smoothing: antialiased;
				}

				:target {
					scroll-margin-top: 300px;
				}

				/* VIMEO PLAYER */
				.videoWrapper iframe,
				.videoWrapper object,
				.videoWrapper embed {
				}

				/* OSANO COOKIE ICON WIDGET */
				.osano-cm-widget {
					display: none;
				}
				.cookie-pref-trigger {
					color: ${colors.green};
					cursor: pointer;
				}
				#jsd-widget {
					z-index: 1000 !important;
				}

				.aapl-table {
					width: 100%;
					max-width: 800px;
					margin: 2rem auto;
					margin-top: 0em;
				}

				.aapl-table table {
					width: 100%;
					border-collapse: collapse;
					box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
					margin-bottom: 1rem;
				}

				.aapl-table th,
				.aapl-table td {
					padding: 1rem;
					text-align: left;
					border: 1px solid #dee2e6;
				}

				/* Header styling */
				.aapl-table th {
					background-color: ${colors.lightGray};
					font-weight: 600;
					text-transform: uppercase;
					border-bottom: 2px solid #dee2e6;
				}

				/* Target the paragraph divs inside table cells */
				.aapl-table .jsx-2484120570.paragraph {
					margin: 0;
					padding: 0.25rem 0;
				}

				/* Style date range row */
				.aapl-table tr:nth-child(1) td i {
					color: #666;
					font-size: 0.9em;
				}

				/* Alternate row colors for the main content */
				.aapl-table tr:nth-child(even) {
					background-color: #f8f9fa;
				}

				.aapl-table tr:hover {
					background-color: #f2f2f2;
				}

				/* Style the notes outside the table */
				.aapl-table .paragraph i {
					color: #666;
					display: block;
					margin-top: 0.5rem;
				}

				/* Bold text color */
				.aapl-table .boldColor {
					color: #333;
				}

				/* Handle empty cells */
				.aapl-table td:empty,
				.aapl-table th:empty {
					border: none;
				}

				/* Responsive styles */
				@media (max-width: 768px) {
					.aapl-table th,
					.aapl-table td {
						padding: 0.5rem;
						font-size: 0.9rem;
					}
				}
			`}</style>
		</div>
	);
}
